import * as React from "react";
import { createStyles, makeStyles, Paper } from "@material-ui/core";
import {
    DataSection,
    domain,
    MessageComposerIconLink,
    PhoneLink,
    RelodeTheme,
    Text,
    Avatar,
    NewMessageIcon,
    PhoneIcon,
} from "../..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            header: {
                marginBottom: 15,
            },
            detailsFlex: {
                display: "flex",
                flexFlow: "row wrap",
                gap: 15,
                alignItems: "center",
            },
            marginZero: {
                marginTop: 0,
            },
            inline: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            },
            contactButton: {
                margin: theme.spacing(0, 1),
                padding: theme.spacing(1, 0, 0, 0),
            },
            phoneContactButton: {
                padding: theme.spacing(1, 0, 0, 0),
            },
            messageIcon: {
                margin: theme.spacing(0, 1),
                verticalAlign: "middle",
            },
        }),
    { name: "ContactView" }
);

interface ContactViewProps {
    label: string;
    jobId?: number;
    jobName?: string;
    contactUserId: number;
    contactProfileImageUrl: string;
    contactName: string;
    contactInitials: string;
    contactPhoneNumber: string;
    actionableLinks: boolean;
    isClient?: boolean;
}

export const ContactView = (props: ContactViewProps) => {
    const {
        label,
        jobId,
        jobName,
        contactInitials,
        contactName,
        contactPhoneNumber,
        contactProfileImageUrl,
        contactUserId,
        actionableLinks,
        isClient
    } = props;
    const classes = useStyles({});

    return (
        <Paper elevation={isClient ? 0 : 1 } className={classes.paper}>
            <Text variant="h2" gutterBottom>contact</Text>
            <div className={classes.detailsFlex}>
                <Avatar
                    src={contactProfileImageUrl}
                    alt={contactName}
                    initials={contactInitials}
                />

                <DataSection
                    label={label}
                    className={classes.marginZero}
                    contentClassName={classes.inline}
                >
                    <>
                        <Text variant="body1" id="jobContactName">
                            {contactName}
                        </Text>
                        {actionableLinks ? (
                            <MessageComposerIconLink
                                id="contactMessage"
                                className={classes.contactButton}
                                initialRecipients={[
                                    {
                                        userId: contactUserId,
                                        displayName: contactName,
                                        roleName:
                                            domain.UserRole.Administrator
                                                .roleName,
                                    },
                                ]}
                                jobId={jobId}
                                jobName={jobName}
                                title={`message ${contactName}`} 
                            />
                        ) : (
                            <NewMessageIcon
                                className={classes.messageIcon}
                                color="primary"
                            />
                        )}

                        {actionableLinks ? (
                            contactPhoneNumber && (
                                <PhoneLink
                                    className={classes.phoneContactButton}
                                    phone={contactPhoneNumber}
                                    variant="iconOnly"
                                />
                            )
                        ) : (
                            <PhoneIcon color="primary" />
                        )}
                    </>
                </DataSection>
            </div>
        </Paper>
    );
};
